<label>{{ label }}</label>
<ng-select
  [items]="factories$ | async"
  bindValue="id"
  bindLabel="factory_name"
  [(ngModel)]="value"
  (change)="onChange()"
  [multiple]="options?.multi"
  style="min-width: 140px"
>
</ng-select>
